export const MAX_STAND_NAME = 20;
